import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

type KbdKeysInput = string | readonly string[];
type KbdSize = 'md' | 'sm';

@Component({
  selector: 'app-kbd',
  template: `
    <span
      class="ct-kbd"
      [class.ct-kbd--sm]="size() === 'sm'"
      [attr.aria-label]="ariaLabel()"
    >
      @for (key of normalizedKeys(); track key + '-' + $index) {
        <kbd class="ct-kbd__key">{{ key }}</kbd>
      }
    </span>
  `,
  styleUrl: './kbd.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KbdComponent {
  /** Single label (e.g. "Esc") or list (e.g. ["⌘", "K"]). */
  readonly keys = input<KbdKeysInput>('Esc');

  /** Visual size. Use `sm` for dense UIs like inputs. */
  readonly size = input<KbdSize>('md');

  /** Optional aria-label override (otherwise joins keys with " + "). */
  readonly ariaLabelOverride = input<string | null>(null);

  readonly normalizedKeys = computed(() => {
    const keys = this.keys();
    const arr = Array.isArray(keys) ? keys : [keys];
    return arr.map((k) => `${k}`.trim()).filter(Boolean);
  });

  readonly ariaLabel = computed(() => {
    const override = this.ariaLabelOverride();
    if (override) return override;
    return this.normalizedKeys().join(' + ');
  });
}

